import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'link-text',
  templateUrl: './link-text.component.html',
  styleUrls: ['./link-text.component.css'],
})
export class LinkTextComponent implements OnInit {
  @Input() text?: string;
  @Input() url?: string;
  @Output() onTapped: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
